import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { Amplify } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import { Header, Sidebar } from "@components";
import { Authenticated, LoginHeader } from "features/auth/components/";
import { amplifyConfig } from "@libs/amplify-config";
import "@aws-amplify/ui-react/styles.css";
import { WaitingOverlayProvider } from "@hooks/waitingOverlay";
import WaitingOverlay from "@hooks/waitingOverlay/WaitingOverlay";
import { BreadcrumbsProvider } from "@hooks/useBreadcrumbs/useBreadcrumbs";
import { contentStyle, contentBodyStyle, contentBodyInnerStyle } from "./styles";

Amplify.configure(amplifyConfig);

const components = {
  Header: LoginHeader,
};

// // Clear session storage if the build version has changed
// const buildKey = "appBuildVersion";
// const prevBuild = window.localStorage.getItem(buildKey);
// if (prevBuild && Number(prevBuild) !== window.appConfig.build) {
//   window.sessionStorage.clear();
// }
// window.localStorage.setItem(buildKey, window.appConfig.build.toString());

export default () => {
  const spinner = document.getElementById("b-spinner-root");
  spinner?.classList.add("hidden");

  return (
    <Authenticator hideSignUp components={components}>
      {({ signOut, user }) => (
        <Authenticated signOut={signOut!} user={user!}>
          <BreadcrumbsProvider>
            <Sidebar />
            <WaitingOverlayProvider>
              <Box sx={contentStyle}>
                <Box sx={contentBodyStyle}>
                  <Box sx={contentBodyInnerStyle}>
                    <Header />
                    <Outlet />
                  </Box>
                </Box>
              </Box>
              <WaitingOverlay />
            </WaitingOverlayProvider>
          </BreadcrumbsProvider>
        </Authenticated>
      )}
    </Authenticator>
  );
};
